import { useEffect } from 'react';

import { PublicRoute } from '../app/guards';
import { COMPANY_NAME, DEFAULT_PAGE_TITLE } from '../brand';
import { useTitle } from '../contexts/TitleContext';
import privacyHtml from '../static/privacy-policy.html?raw';

export function PrivacyPolicyPage() {
  const { setTitle } = useTitle();
  useEffect(() => {
    setTitle(`Privacy Policy - ${COMPANY_NAME}`);
    return () => setTitle(DEFAULT_PAGE_TITLE);
  }, [setTitle]);
  return (
    <PublicRoute static>
      <div className="page-container">
        <div dangerouslySetInnerHTML={{ __html: privacyHtml }} />
      </div>
    </PublicRoute>
  );
}
